import { UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import {
  PatchScheduledMessageResponseTO,
  ScheduledMessageUpdatePayload,
} from 'models/automation/ScheduledMessages';
import API from 'services/API';
import { SCHEDULED_MESSAGES_BASE_QUERY_KEY } from './scheduledMessagesQuery';

type UpdateScheduledMessageMutationArgs = ScheduledMessageUpdatePayload & {
  scheduledMessageUid: string;
};

type ReactQueryMutationOptions = Omit<
  UseMutationOptions<
    PatchScheduledMessageResponseTO,
    BaseErrorResponse,
    UpdateScheduledMessageMutationArgs
  >,
  'mutationFn' | 'mutationKey'
>;

const updateScheduledMessage = ({
  scheduledMessageUid,
  ...payload
}: UpdateScheduledMessageMutationArgs) => {
  return API.patch<PatchScheduledMessageResponseTO, BaseErrorResponse>(
    `/api/internal/triggers/scheduled-messages/${scheduledMessageUid}`,
    payload,
  );
};

const useUpdateScheduledMessageMutation = ({
  onSuccess,
  ...options
}: ReactQueryMutationOptions = {}) => {
  const queryClient = useQueryClient();

  return useAppMutation({
    mutationFn: updateScheduledMessage,
    onSuccess: (...args) => {
      queryClient.invalidateQueries([SCHEDULED_MESSAGES_BASE_QUERY_KEY]);
      return onSuccess?.(...args);
    },
    ...options,
  });
};

export default useUpdateScheduledMessageMutation;
